import './practice-carousel.scss';


if (!window.dAgency) window.dAgency = {};
window.dAgency.initPracticeCarousel = (context) => {

  const carousel_banner = context.closest('.shopify-section');

  if (carousel_banner) {
    const slider = carousel_banner.querySelector('[data-practice-carousel]');

    new Swiper(slider, {
      slidesPerView: 1.25,
      spaceBetween: 32,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {

        480: {
          slidesPerView: 1.25
        },

        1024: {
          slidesPerView: 3
        },

        1200: {
          slidesPerView: 4
        }
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.practice-carousel__container'), (el) => {
    window.dAgency.initPracticeCarousel(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.practice-carousel__container'), (el) => {
      window.dAgency.initPracticeCarousel(el);
    });
  });
}

